// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__MDKXe","ant-page-header-heading-title":"styles_ant-page-header-heading-title__YcnAy","table":"styles_table__jPsul"};